// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.import-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.15s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.import-modal {
  background: #161b22;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 1.5rem;
  width: 100%;
  max-width: 420px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 16px 64px rgba(0, 0, 0, 0.5);
  animation: slideUp 0.2s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.import-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.25rem;
}

.import-modal-header h3 {
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
}

.import-modal-close {
  background: transparent;
  border: none;
  padding: 0.25rem;
  cursor: pointer;
  color: #6b7280;
  transition: color 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.import-modal-close:hover {
  color: #e5e7eb;
}

.import-modal-close svg {
  width: 20px;
  height: 20px;
}

.import-drop-zone {
  border: 2px dashed rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 2.5rem 1.5rem;
  text-align: center;
  transition: all 0.2s ease;
  background: rgba(255, 255, 255, 0.02);
}

.import-drop-zone.dragging {
  border-color: #3b82f6;
  background: rgba(59, 130, 246, 0.08);
}

.import-drop-zone.loading {
  pointer-events: none;
}

.import-icon {
  width: 48px;
  height: 48px;
  color: #6b7280;
  margin-bottom: 1rem;
}

.import-drop-zone.dragging .import-icon {
  color: #3b82f6;
}

.import-text {
  color: #e5e7eb;
  font-size: 0.95rem;
  font-weight: 500;
  margin: 0 0 0.5rem;
}

.import-subtext {
  color: #6b7280;
  font-size: 0.8rem;
  margin: 0 0 0.75rem;
}

.import-browse-btn {
  background: rgba(59, 130, 246, 0.15);
  border: 1px solid rgba(59, 130, 246, 0.3);
  color: #60a5fa;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}

.import-browse-btn:hover {
  background: rgba(59, 130, 246, 0.25);
  border-color: rgba(59, 130, 246, 0.5);
}

.import-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  color: #9ca3af;
  font-size: 0.9rem;
}

.import-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid rgba(59, 130, 246, 0.2);
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.import-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
  padding: 0.75rem;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: 8px;
  color: #f87171;
  font-size: 0.85rem;
}

.import-error svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.import-hint {
  margin: 1rem 0 0;
  padding: 0;
  color: #6b7280;
  font-size: 0.75rem;
  text-align: center;
}

.import-hint code {
  background: rgba(255, 255, 255, 0.08);
  padding: 0.15rem 0.35rem;
  border-radius: 4px;
  font-family: monospace;
  font-size: 0.7rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/ImportReportModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB","sourcesContent":[".import-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.15s ease-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.import-modal {\n  background: #161b22;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 1.5rem;\n  width: 100%;\n  max-width: 420px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 16px 64px rgba(0, 0, 0, 0.5);\n  animation: slideUp 0.2s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.import-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.25rem;\n}\n\n.import-modal-header h3 {\n  color: #ffffff;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.import-modal-close {\n  background: transparent;\n  border: none;\n  padding: 0.25rem;\n  cursor: pointer;\n  color: #6b7280;\n  transition: color 0.15s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.import-modal-close:hover {\n  color: #e5e7eb;\n}\n\n.import-modal-close svg {\n  width: 20px;\n  height: 20px;\n}\n\n.import-drop-zone {\n  border: 2px dashed rgba(255, 255, 255, 0.15);\n  border-radius: 12px;\n  padding: 2.5rem 1.5rem;\n  text-align: center;\n  transition: all 0.2s ease;\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.import-drop-zone.dragging {\n  border-color: #3b82f6;\n  background: rgba(59, 130, 246, 0.08);\n}\n\n.import-drop-zone.loading {\n  pointer-events: none;\n}\n\n.import-icon {\n  width: 48px;\n  height: 48px;\n  color: #6b7280;\n  margin-bottom: 1rem;\n}\n\n.import-drop-zone.dragging .import-icon {\n  color: #3b82f6;\n}\n\n.import-text {\n  color: #e5e7eb;\n  font-size: 0.95rem;\n  font-weight: 500;\n  margin: 0 0 0.5rem;\n}\n\n.import-subtext {\n  color: #6b7280;\n  font-size: 0.8rem;\n  margin: 0 0 0.75rem;\n}\n\n.import-browse-btn {\n  background: rgba(59, 130, 246, 0.15);\n  border: 1px solid rgba(59, 130, 246, 0.3);\n  color: #60a5fa;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.import-browse-btn:hover {\n  background: rgba(59, 130, 246, 0.25);\n  border-color: rgba(59, 130, 246, 0.5);\n}\n\n.import-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  color: #9ca3af;\n  font-size: 0.9rem;\n}\n\n.import-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid rgba(59, 130, 246, 0.2);\n  border-top-color: #3b82f6;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.import-error {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 1rem;\n  padding: 0.75rem;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  border-radius: 8px;\n  color: #f87171;\n  font-size: 0.85rem;\n}\n\n.import-error svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.import-hint {\n  margin: 1rem 0 0;\n  padding: 0;\n  color: #6b7280;\n  font-size: 0.75rem;\n  text-align: center;\n}\n\n.import-hint code {\n  background: rgba(255, 255, 255, 0.08);\n  padding: 0.15rem 0.35rem;\n  border-radius: 4px;\n  font-family: monospace;\n  font-size: 0.7rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
